var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor-new-noedit',{attrs:{"title":"Content Text"},model:{value:(_vm.config.settings.body_html),callback:function ($$v) {_vm.$set(_vm.config.settings, "body_html", $$v)},expression:"config.settings.body_html"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }